<div class="dialogContainer">
  <div class="content">
    @for (message of messages; track message) {
      <p class="message-entry">{{message}}</p>
    }
  </div>
  <div class="buttonBar">
    <span class="spacer"></span>
    <button class="primary-button" matButton="elevated" (click)="close()">OK</button>
    <span class="spacer"></span>
  </div>
</div>
